<template>
  <div>
    <ul class="uk-margin-medium-bottom" uk-tab>
      <li @click="displayed('product-families')"> <a>{{ $t('tabs.productFamiliesActiveRevisions') }}: {{
        activeRevisions['product_families'] }}</a></li>

      <li @click="displayed('products')"> <a>{{ $t('tabs.productsActiveRevisions') }}: {{ activeRevisions['products']
      }}</a> </li>

      <li @click="displayed('offers')"> <a>{{ $t('tabs.offersActiveRevisions') }}: {{ activeRevisions['offers'] }}</a>
      </li>

      <li @click="displayed('contracts')"> <a>{{ $t('tabs.contractsActiveRevisions') }}: {{ activeRevisions['contracts']
      }}</a> </li>
    </ul>
    <div>
      <ProductFamiliesActiveRevisionsIndexView v-show="isDisplayed == 'product-families'"
        @update-active-revisions="updateActiveRevisions">
      </ProductFamiliesActiveRevisionsIndexView>
      <ProductsActiveRevisionsIndexView v-show="isDisplayed == 'products'"
        @update-active-revisions="updateActiveRevisions">
      </ProductsActiveRevisionsIndexView>
      <OffersActiveRevisionsIndexView v-show="isDisplayed == 'offers'" @update-active-revisions="updateActiveRevisions">
      </OffersActiveRevisionsIndexView>
      <ContractsActiveRevisionsIndexView v-show="isDisplayed == 'contracts'"
        @update-active-revisions="updateActiveRevisions">
      </ContractsActiveRevisionsIndexView>
    </div>
  </div>
</template>

<script>
import View from '@/mixins/View';
import ProductFamiliesActiveRevisionsIndexView
  from '@/views/ActiveRevisions/ProductFamiliesActiveRevisionsIndexView';
import OffersActiveRevisionsIndexView
  from '@/views/ActiveRevisions/OffersActiveRevisionsIndexView';
import ProductsActiveRevisionsIndexView
  from '@/views/ActiveRevisions/ProductsActiveRevisionsIndexView';
import ContractsActiveRevisionsIndexView
  from '@/views/ActiveRevisions/ContractsActiveRevisionsIndexView';

export default {
  name: 'active-revisions-view',
  data() {
    return {
      isDisplayed: 'product-families',
      activeRevisions: {
        product_families: 0,
        products: 0,
        offers: 0,
        contracts: 0,
      },
    };
  },
  components: {
    ProductFamiliesActiveRevisionsIndexView,
    OffersActiveRevisionsIndexView,
    ProductsActiveRevisionsIndexView,
    ContractsActiveRevisionsIndexView,
  },
  mixins: [View],
  methods: {
    displayed(path) {
      history.replaceState({}, '/',
        `${this.$route.path}#${path}`);
      this.isDisplayed = path;
    },
    updateActiveRevisions(index, updatedValue) {
      this.$set(this.activeRevisions, index, updatedValue);
    },
  },
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'activeRevisions',
          route: { name: 'active-revisions' },
        },
      ];
    },
  },
  created() {
    history.replaceState({}, '/',
      `${this.$route.path}#product-families`);
  },
  i18n: {
    messages: {
      de: {
        breadcrumbs: {
          activeRevisions: 'Active Revsions',
        },
        tabs: {
          productFamiliesActiveRevisions: 'Product Families',
          offersActiveRevisions: 'Offers',
          productsActiveRevisions: 'Products',
          contractsActiveRevisions: 'Contracts',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ActiveRevisionsView.vue?5e1e9352